import { useEffect, useState } from "react";
import { apiFetch } from "api/Api";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Link } from "react-router-dom";
import { FaPlus, FaEdit, FaTrash, FaListUl, FaCode, FaTag, FaCalendarAlt, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import "assets/theme/admin_list.css";

const CategoryFieldList = () => {
  const [fields, setFields] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadFields();
  }, []);

  const loadFields = async () => {
    setLoading(true);
    try {
      const data = await apiFetch("super_admin/get_category_wise_field");
      setFields(data.category_fields || []);
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this field?")) return;

    try {
      await apiFetch(`super_admin/delete_category_wise_field/${id}`, {
        method: "DELETE",
      });
      alert("Field deleted successfully");
      loadFields();
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid py-3">
        {/* Header Card */}
        <div className="admin-header-card mb-4">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 position-relative" style={{ zIndex: 1 }}>
            <div className="d-flex align-items-center gap-3">
              <div className="admin-header-icon-box">
                <FaListUl />
              </div>
              <div>
                <h4 className="text-white fw-bold mb-1" style={{ fontSize: "1.3rem" }}>
                  Category Fields List / श्रेणी फील्ड यादी
                </h4>
                <p className="text-white-50 mb-0" style={{ fontSize: "0.88rem" }}>
                  Manage dynamic form fields for various complaint & service categories
                </p>
              </div>
            </div>

            <Link to="/add_template_field" className="btn btn-admin-add">
              <FaPlus /> <span>Add Field / नवीन फील्ड</span>
            </Link>
          </div>
        </div>

        {/* List Card */}
        <div className="admin-table-card">
          <div className="card-body p-0">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-warning" role="status"></div>
                <p className="text-muted mt-2 fw-semibold mb-0">माहिती लोड होत आहे...</p>
              </div>
            ) : fields.length === 0 ? (
              <div className="text-center py-5">
                <FaTag className="text-muted mb-3" style={{ fontSize: "2.5rem", opacity: 0.4 }} />
                <h6 className="text-muted fw-bold">No fields found</h6>
                <p className="text-muted small mb-0">No custom category fields have been configured yet.</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-admin-custom align-middle">
                  <thead>
                    <tr>
                      <th style={{ width: "80px" }}>Sr. No.</th>
                      <th>Category / श्रेणी</th>
                      <th>Field Label / नाव</th>
                      <th>Field Key / की</th>
                      <th>Type / प्रकार</th>
                      <th>Required / आवश्यक</th>
                      <th>Created / दिनांक</th>
                      <th className="text-center" style={{ width: "120px" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fields.map((field, index) => (
                      <tr key={field.field_id}>
                        <td>
                          <span className="fw-semibold text-muted">{(index + 1).toString().padStart(2, "0")}</span>
                        </td>
                        <td>
                          <span className="fw-bold text-dark">{field.category_name}</span>
                        </td>
                        <td>
                          <span className="fw-semibold text-primary">{field.field_label}</span>
                        </td>
                        <td>
                          <span className="badge bg-light text-dark font-monospace border px-2 py-1">
                            <FaCode className="me-1 text-secondary" style={{ fontSize: "0.75rem" }} />
                            {field.field_key}
                          </span>
                        </td>
                        <td>
                          <span className="badge bg-info bg-opacity-10 text-info fw-semibold px-2 py-1 rounded-pill">
                            {field.field_type}
                          </span>
                        </td>
                        <td>
                          {field.is_required ? (
                            <span className="badge bg-danger bg-opacity-10 text-danger fw-semibold px-2 py-1 rounded-pill">
                              <FaCheckCircle className="me-1" /> Required
                            </span>
                          ) : (
                            <span className="badge bg-secondary bg-opacity-10 text-secondary fw-semibold px-2 py-1 rounded-pill">
                              <FaTimesCircle className="me-1" /> Optional
                            </span>
                          )}
                        </td>
                        <td>
                          <small className="text-muted">
                            <FaCalendarAlt className="me-1" />
                            {new Date(field.created_at).toLocaleDateString("en-IN")}
                          </small>
                        </td>
                        <td>
                          <div className="d-flex justify-content-center gap-2">
                            <Link
                              to={`/edit_category_field/${field.field_id}`}
                              className="btn-action-icon edit"
                              title="Edit Field"
                            >
                              <FaEdit />
                            </Link>
                            <button
                              onClick={() => handleDelete(field.field_id)}
                              className="btn-action-icon delete"
                              title="Delete Field"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default CategoryFieldList;
